import { goToShop, onError } from '@/app/routing/events'
import { goToAuth } from '@/app/routing/events'
import { $userToken } from '@/entities/user'
import { useUnit } from 'effector-react'
import { getUserProfile } from '@/entities/user/api'
import { openCaseFx } from '@/entities/cases/effects'
import { goToReward } from '@/app/routing/events'

import { $lastViewedCaseId, $lastViewedCasePrice, $userKeys } from '@/entities/cases/store'
import { useEffect, useState } from 'react'
import { useBuyKeys } from './useBuyKeys'

import { setOpenedLbKind } from '@/entities/cases/events'
export const useOpenCase = () => {
  const userToken = useUnit($userToken)
  const caseId = useUnit($lastViewedCaseId) ?? 1
  const [isModalOpen, setIsModalOpen] = useState(false)
  const userKeys = useUnit($userKeys)

  const boxPrice = useUnit($lastViewedCasePrice) ?? 1
  const [isPriceGreaterThanBalance, setIsPriceGreaterThanBalance] = useState(false)

  useEffect(() => {
    if (boxPrice! > userKeys!) {
      setIsPriceGreaterThanBalance(true)
    } else {
      setIsPriceGreaterThanBalance(false)
    }
  }, [boxPrice, userKeys])

  const { handleBuyKeys } = useBuyKeys()

  const handleOpenCase = () => {
    if (!userToken) return goToAuth()

    if (isPriceGreaterThanBalance) {
      goToShop({ tab: 2 })
      return
    } else {
      openCaseFx({ token: userToken, id: caseId })
        .then(() => {
          getUserProfile(userToken)
          setOpenedLbKind(false)
          goToReward()
        })
        .catch(onError)
    }
  }

  return { handleOpenCase, isModalOpen, setIsModalOpen, handleBuyKeys }
}
